import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import { store } from './store/store'
const fb = require('./firebase/firebase')
import * as VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

Vue.config.productionTip = false

let app
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
